import {makeStyles, Menu, MenuItem} from "@material-ui/core";
import {useRef, useState} from "react";

const useStyles = makeStyles(() => ({
  dotIcon: {
    width: 25,
    height: 25,
    cursor: 'pointer',
    verticalAlign:'middle'
  },
  menuItem: {
    padding: 0
  },
  btn: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    textTransform: 'unset',
    marginRight: 30,
    marginLeft: 30,
    width: '100%'
  }
}));

interface IProps {
  editTag: () => void
  removeParticipant: () => void
}

function DotMenu(props: IProps) {
  const classes = useStyles();
  const { editTag, removeParticipant } = props;
  const anchorRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);

  const handleMenuOpen = () => {
    setOpenMenu(true);
  };

  const handleMenuClose = () => {
    setOpenMenu(false);
  };

  const onEditTag = () => {
    setOpenMenu(false);
    editTag();
  };

  const onRemove = () => {
    setOpenMenu(false);
    removeParticipant();
  };

  return (
    <div>
      <img
        src={'/assets/icons/participant/dots-menu.svg'}
        alt='dot menu'
        className={classes.dotIcon}
        ref={anchorRef}
        onClick={handleMenuOpen}
      />
      <Menu
        anchorEl={anchorRef.current}
        onClose={handleMenuClose}
        open={openMenu}
        PaperProps={{
          style: {width: 'auto', marginTop: 50, borderRadius: 12}
        }}
      >
        {['Manage Tags', 'Remove Participant'].map((option, index) => (
          <MenuItem
            className={classes.menuItem}
            key={option}
            onClick={() => index === 0 ? onEditTag() : onRemove()}
          >
            <p className={classes.btn}>{option}</p>
          </MenuItem>
        ))}
      </Menu>
    </div>
  )
}

export default DotMenu;